import React from 'react';
import { useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import '../POTemplate.css';
import { usePOTemplateDnd } from './contextProvider/POTemplateDndContext';
import CompanyAndSupplierDetailsTemplate from './CompnayAndSupplierTempalte';
import POdetails from './POdetails';
import ShippingDetails from './ShippingDetails';
import GrandTotal from './GrandTotal';
import Section from './Section';
import ConfirmationModal from '../../../../Components/ModalPopup/ConfirmationPopup';
import OrderDetails from './OrderDetails';
import ControlPropertiesModal from './ControlPropertiesModal';

function DropZone({ onDrop, position, t }) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: 'SECTION',
    drop: (item) => {
      onDrop(item, position);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div
      ref={drop}
      className={`potemplate-drop-zone${isOver && canDrop ? ' potemplate-drop-active' : ''}`}
      style={{
        minHeight: isOver && canDrop && '40px',
        transition: 'min-height 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isOver && canDrop && <div className="potemplate-drop-hint">{t('PO_TEMPLATE.DETAIL_PAGE.DROP_SECTION_HERE')}</div>}
    </div>
  );
}

export default function RightPanel() {
  const { dispatch, detailState, setDetailState } = usePOTemplateDnd();
  const { t } = useTranslation('purchase-order');

  const handleDrop = (item, position) => {
    dispatch({
      type: 'ADD_SECTION',
      id: Date.now(),
      columns: item.columns,
      position,
      name: 'Custom Section',
    });
  };

  const toggleDeleteModal = () => {
    setDetailState((prevState) => ({
      ...prevState,
      showDeleteSectionModal: false,
      deleteSectionId: null,
      deleteSectionName: '',
    }));
  };

  const deleteSectionConfirm = () => {
    dispatch({
      type: 'DELETE_SECTION',
      sectionId: detailState?.deleteSectionId,
    });
    toggleDeleteModal();
  };

  const closeControlPropertiesModal = () => {
    setDetailState((prevState) => ({
      ...prevState,
      showControlPropertiesModal: false,
      editingControl: null,
      editingControlData: null,
    }));
  };

  const renderSectionsInOrder = () => {
    const sections = detailState?.sections || [];
    const renderedSections = [];

    renderedSections.push(<POdetails key="po-details" isPreviewMode={false} />);
    renderedSections.push(<CompanyAndSupplierDetailsTemplate key="company-supplier" />);

    if (sections.length > 0) {
      renderedSections.push(<DropZone key="drop-zone-start" onDrop={handleDrop} position="start" t={t} />);
    }

    const sortedSections = [...sections].sort((a, b) => a.sequence - b.sequence);

    sortedSections.forEach((section, index) => {
      if (section.sectionKey === 'shipping_details_section') {
        renderedSections.push(<ShippingDetails key="shipping-details" isPreviewMode={false} />);
      } else if (section.sectionKey === 'grand_total_section') {
        renderedSections.push(<GrandTotal key="grand-total" isPreviewMode={false} />);
      } else if (section.sectionKey === 'order_details_section') {
        renderedSections.push(<OrderDetails key="order-details" isPreviewMode={false} />);
      } else if (!section.sectionKey) {
        renderedSections.push(<Section key={`custom-${section.id}`} section={section} sectionIdx={index} isPreviewMode={false} />);
      }

      if (index < sortedSections.length - 1) {
        const nextSection = sortedSections[index + 1];
        renderedSections.push(<DropZone key={`drop-zone-after-${section.id}`} onDrop={handleDrop} position={nextSection.id.toString()} t={t} />);
      }
    });

    renderedSections.push(<DropZone key="drop-zone-end" onDrop={handleDrop} position="end" t={t} />);

    return renderedSections;
  };

  return (
    <>
      <div className={`flex-fill p-24 bg-white h-100 overflow-auto pb-24 ${detailState?.showControlPropertiesModal ? 'modal-open' : ''}`}>
        <div className="po-wrapper mb-80">{renderSectionsInOrder()}</div>
      </div>
      <ConfirmationModal
        onOpen={detailState?.showDeleteSectionModal}
        toggle={toggleDeleteModal}
        title={`${t('COMMON_LABEL.DELETE')} ${detailState?.deleteSectionName}`}
        message={t('PO_TEMPLATE.DETAIL_PAGE.DELETE_SECTION_MESSAGE')}
        onConfirm={deleteSectionConfirm}
      />
      <ControlPropertiesModal
        isOpen={detailState?.showControlPropertiesModal}
        onClose={closeControlPropertiesModal}
        control={detailState?.editingControl}
        sectionId={detailState?.editingControlData?.sectionId}
        columnIdx={detailState?.editingControlData?.columnIdx}
        controlIdx={detailState?.editingControlData?.controlIdx}
      />
    </>
  );
}
